export const UI_VERSION = "2.5.0";
export const TAX_YEAR = new Date().getFullYear() - 1;

// Belegbox / Snapshare document tax year selection: fixed floor year the
// feature launched with, capped to a rolling window of 5 selectable years.
const MIN_SELECTABLE_TAX_YEAR = 2025;
const MAX_SELECTABLE_TAX_YEARS = 5;

// Launch year (2026, when TAX_YEAR is still 2025) gets a one-time +1 bump
// since development starts before 2026 would normally become selectable.
// From 2027 onward this is just TAX_YEAR.
export const NEWEST_SELECTABLE_TAX_YEAR =
  TAX_YEAR === MIN_SELECTABLE_TAX_YEAR ? TAX_YEAR + 1 : TAX_YEAR;

export const SELECTABLE_TAX_YEARS = (() => {
  const startYear = Math.max(
    MIN_SELECTABLE_TAX_YEAR,
    NEWEST_SELECTABLE_TAX_YEAR - (MAX_SELECTABLE_TAX_YEARS - 1)
  );
  const years = [];
  for (let year = NEWEST_SELECTABLE_TAX_YEAR; year >= startYear; year--) {
    years.push(year);
  }
  return years;
})();
